var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActions = function SvgActions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.722 14.895v-3.316m0 0V6.158c0-.916.73-1.658 1.633-1.658.902 0 1.633.742 1.633 1.658v4.474l2.872.452c1.8.274 2.7.411 3.334.797C18.241 12.517 19 13.474 19 14.87c0 .972-.237 1.624-.812 3.377-.366 1.112-.548 1.668-.846 2.109a3.74 3.74 0 0 1-2.046 1.496c-.505.148-1.083.148-2.238.148h-1.311c-1.666 0-2.498 0-3.214-.317a3.7 3.7 0 0 1-.895-.562c-.6-.507-.972-1.263-1.717-2.775-.604-1.227-.906-1.84-.92-2.475-.007-.287.03-.573.107-.849.172-.611.617-1.127 1.506-2.159z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.316 6a4 4 0 0 0-8 0"
  })));
};
export default SvgActions;